import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import type { FC } from "react";
import { useEffect, useState } from "react";
import type { CmsComponent } from "./CmsComponentsApi";

interface Props {
  readonly open: boolean;
  readonly componentId: string;
  readonly component?: CmsComponent;
  readonly onClose: () => void;
  readonly onSave: (component: CmsComponent) => Promise<void>;
}

const EditCmsComponent: FC<Props> = ({ open, componentId, component, onClose, onSave }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [buttonLabel, setButtonLabel] = useState("");
  const [buttonLink, setButtonLink] = useState("");

  useEffect(() => {
    if (open) {
      setTitle(component?.title ?? "");
      setDescription(component?.description ?? "");
      setButtonLabel(component?.buttonLabel ?? "");
      setButtonLink(component?.buttonLink ?? "");
    }
  }, [open, component]);

  const handleSave = async () => {
    await onSave({ id: componentId, title, description, buttonLabel, buttonLink });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{component ? "Edytuj treść" : "Dodaj treść"}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Nazwa"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Opis"
          fullWidth
          multiline
          rows={3}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Etykieta przycisku"
          fullWidth
          value={buttonLabel}
          onChange={(e) => setButtonLabel(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Link przycisku"
          fullWidth
          value={buttonLink}
          onChange={(e) => setButtonLink(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Anuluj</Button>
        <Button onClick={handleSave} disabled={!title || !description || !buttonLabel || !buttonLink}>
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCmsComponent;
